import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import {getData_retData} from 'engine/dataServices';
import jMoment from 'moment-jalaali';
import ContainerHeader from 'components/ContainerHeader/index';
import InfoCard from 'components/InfoCard';
import ApallShareImage from 'assets/Images/SwiftImageIcons/Colored/1x/Shakinghands.png';
import ToDayCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mobilepay.png';
import TotalCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mastercard.png';


let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return {id: counter, name, calories, fat, carbs, protein};
}

const columnData = [
    {id: 'Id', numeric: false, disablePadding: true, label: 'شناسه'},
    {id: 'Price', numeric: false, disablePadding: true, label: 'مبلغ تسویه (تومان)'},
    {id: 'IsApproved', numeric: false, disablePadding: true, label: 'وضعیت'},
    {id: 'TrackingCode', numeric: false, disablePadding: true, label: 'کد رهگیری'},
    {id: 'CreateDate', numeric: false, disablePadding: true, label: 'تاریخ ثبت'},
    {id: 'ModifiedDate', numeric: false, disablePadding: true, label: 'تاریخ تایید'},
];

class DataTableHead extends React.Component {

    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount} = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                                className='text-center'
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let DataTableToolbar = props => {
    const {numSelected} = props;

    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                {numSelected > 0 ? (
                    <Typography type="subheading">{numSelected} ردیف انتخاب شده</Typography>
                ) : (
                    <Typography type="title">تاریخچه تسویه های انجام شده با اپال</Typography>
                )}
            </div>
            <div className="spacer"/>
            <div className="actions">
                {numSelected > 0 && (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

DataTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class Index extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.data.map(n => n.id)});
            return;
        }
        this.setState({selected: []});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;


    constructor(props, context) {
        super(props, context);

        this.props.handleLoading(true);

        this.loadData();

        this.state = {
            apallShare: '...',
            toDayCount: '...',
            totalCount: '...',
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 5
        };



    }

    async loadData() {

        var response = await getData_retData('/api/Settlement/Get?developerId=7');

        this.props.handleLoading(false);

        this.setState({
            data: response.Settlement,
            apallShare: response.ApallShare.toLocaleString(),
            toDayCount: response.ToDayCount.toLocaleString(),
            totalCount: response.TotalCount.toLocaleString(),
        });

    }

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page, apallShare, toDayCount, totalCount} = this.state;


        const toDayCard = {
            img: ToDayCountImage,
            title: 'در آمد امروز شما',
            subTitle: `${toDayCount} تومان`
        };
        const totalCard = {
            img: TotalCountImage,
            title: 'کل در آمد شما',
            subTitle: `${totalCount} تومان`
        };
        const apallShareCount = {
            img: ApallShareImage,
            title: 'سهم باقیمانده اپال',
            subTitle: `${apallShare} تومان`
        };


        return (
            <div>
                <ContainerHeader match={this.props.match} title="تسویه با اپال"/>

                <div className="row">
                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 col-12">
                        <InfoCard data={toDayCard} styleName="bg-red darken-1 text-white"/>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 col-12">
                        <InfoCard data={totalCard} styleName="bg-teal accent-4 text-white"/>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 col-12">
                        <InfoCard data={apallShareCount} styleName="bg-red text-white"/>
                    </div>

                </div>

                <Paper>
                    <DataTableToolbar numSelected={selected.length}/>

                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table className="">
                                <DataTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => this.handleClick(event, n.id)}
                                                onKeyDown={event => this.handleKeyDown(event, n.id)}
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.id}
                                                selected={isSelected}
                                            >
                                                <TableCell padding="none" className="text-center">{n.Id}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Price.toLocaleString()}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{(n.IsApproved) ? 'تایید شده' : 'در انتظار تایید'}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.TrackingCode}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{jMoment(n.CreateDate).format('HH:mm - jYYYY/jMM/jDD')}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{(n.ModifiedDate) ? jMoment(n.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'در انتظار تایید...'}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
            </div>
        );

    }
}

export default Index;



// WEBPACK FOOTER //
// ./app/routes/apall/Settlement/index.js